module.exports = __webpack_public_path__ + "img/icon21.951769f8.png";